import { utc } from '@date-fns/utc'
import { formatDate } from 'date-fns'

export const formatDateForDisplay = (date) => {
  if (!date) {
    return '-'
  }

  return formatDate(date, 'MM/dd/yyyy', { in: utc })
}

export const hasEmptyValue = (value: any | null | undefined) => value === null || value === undefined || value === ''

export const toSentenceCase = (str: string) =>
  str
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/(^\w|\s\w)/g, (match) => match.toUpperCase())

export const hasMissingRequiredField = (values: (any | null | undefined)[]) =>
  values.some((value) => hasEmptyValue(value))

export const formattedErrorMessage = (message: string) => {
  if (!message) {
    return null
  }

  const cleanedMessage = message.replace(/validation_error:/gi, '').trim()
  return cleanedMessage || null
}
